<template>
    <div class="successDialogBox">
        <div class="topTile">
            <span class="closeBtn" @click="returntwo"></span>
            <span>{{ $t('withdrawalLogin.applicationSuccess') }}</span>
        </div>
        <div class="successImg">
            <div>
                <span class="successIcon"></span>
                <span class="successTxt">{{ $t('withdrawalLogin.success') }}</span>
            </div>
            <div class="successDec" v-html="pnreturnMsg">
            </div>
        </div>
        <div class="amountBox">
            {{ detailsNewObj.cc }} {{ detailsNewObj.num }}
        </div>
        <div class="transferFundsBox">
            <div class="transferFundItem">
                <span>{{ withdrawAmount }}</span>
                <span>{{ detailsNewObj.cc }} {{ detailsNewObj.num }}</span>
            </div>
            <div class="transferFundItem">
                <span>{{ $t('withdrawalLogin.applicationTime') }}</span>
                <span>{{ dateTime }}</span>
            </div>
            <div>
        </div>
    </div>
    <div class="okBtn" @click="returntwo">OK</div>
</div>
</template>
<script>
export default {
    name: "successDialog",
    props:['detailsNewObj','pnreturnMsg','withdrawAmount'],
    data() {
        return {
           dateTime:'2025/04/29'
        }
    },
    created() {
        this.formatDate()
    },
    methods: {
        returntwo() {
            this.$router.push("/withdrawal");
        },
          //时间格式化
        formatDate() {
            function add0(m) { return m < 10 ? '0' + m : m }
            var time = new Date();
            var y = time.getFullYear();
            var m = time.getMonth() + 1;
            var d = time.getDate();
            this.dateTime = y + '/' + add0(m) + '/' + add0(d);
        }
    }
}
</script>
<style>
.okBtn{
    width: 422px;
    height: 88px;
    text-align: center;
    border: 1px solid #AFA9B4;
    border-radius: 44px;
    font-size: 28px;
    line-height: 88px;
    color: #262427;
    font-weight: 500;
    position: absolute;
    bottom: 68px;
    left: 50%;
    transform: translateX(-50%);
}
.successDialogBox{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    font-family: 'Mada';
    padding-top: env(safe-area-inset-top);
    padding-top: constant(safe-area-inset-top);
    box-sizing: border-box;
    z-index: 99;
}
/* 与 withdrawalDetails .hound 顶栏尺寸一致（2026-05-08） */
.topTile{
    width: 100%;
    height: 130px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 30px;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    box-sizing: border-box;
    font-size: 30px;
    font-weight: 600;
}
.closeBtn{
    position: absolute;
    left: 28px;
    top: 50%;
    /* transform: translateY(-50%); */
    width: 28px;
    height: 28px;
    background-image: url('../../assets/h5/back2.png');
    background-size: 100% 100%;
}
html[lang="ar"] .closeBtn {
    left: auto;
    right: 28px;
    transform: translateY(-50%) rotateY(180deg);
}
.successImg{
    width: 100%;
    /* height: 222px; */
    background-color: #4FAE7A;
    padding: 40px 80px;
    box-sizing: border-box;
}
.successImg>div{
    display: flex;
    align-items: center;
    justify-content: center;
}
.successIcon{
    width: 80px;
    height: 80px;
    background-image: url('../../assets/h5/success.png');
    background-size: 100% 100%;
}
.successTxt{
    font-size: 40px;
    line-height: 80px;
    font-weight: 600;
    color: #fff;
    margin-left: 20px;
}
.successDec{
    font-size: 24px;
    line-height: 36px;
    font-weight: 500;
    color: #fff;
    margin-top: 20px;
    text-align: center;
}
.amountBox{
    font-size: 48px;
    line-height: 146px;
    color: #000;
    font-weight: 900;
    text-align: center;
    width: 584px;
    margin: 0 auto;
    border-bottom: 1px solid #eee;
}
.transferFundsBox{
    margin-top: 32px;
    width: 584px;
    margin: 32px auto 0;
}
.transferFundItem{
    display: flex;    
    justify-content: space-between;

}
.transferFundItem span:nth-of-type(1){
    font-size: 24px;
    line-height: 74px;
    font-weight: 500;
    color: #89848D;
}
.transferFundItem span:nth-of-type(2){
    font-size: 28px;
    line-height: 74px;
    font-weight: 500;
    color: #000;
}
</style>